import {useTranslation} from 'react-i18next'
import {PageHeading} from '@/components/page-heading'
import {NoAccessState} from '@/components/no-access-state'
import {SolicitudesSstSection} from '@/components/sst/solicitudes-sst-section'
import {useIsSystemUser} from '@/hooks/empresa/organizacion/use-businesses'

/** Cola de empresas que piden un responsable del SG-SST; no abre ningún tenant: el admin las
 * contacta por fuera y marca la solicitud atendida o descartada. */
export function AdminSstPage() {
  const {t} = useTranslation()
  const isSystemUser = useIsSystemUser()

  if (!isSystemUser) return <NoAccessState />

  return (
    <div className="space-y-5" data-testid="admin-sst">
      <PageHeading title={t('solicitudesSst.admin.title')} />
      <SolicitudesSstSection />
    </div>
  )
}
